import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { ListsFactory } from "../../factories/ListsFactory"
import { EditorComponentContract } from '../EditorComponentContract'

export class Lists extends EditorComponentContract {
  constructor() {
    super(Variations);
    this.htmlBuilder = HtmlBuilder
    this.factory = new ListsFactory
  }

  info() {
    return {
      name: 'Lists',
      icon: 'fa-list',
      variations: this.variationsInfo()
    }
  }

  elementIds() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
    ]
  }

  elementClasses() {
    return [
      'classes', 'listsClasses', 'containerClasses', 'descContainerClasses', 'iconContainerClasses', 'itemClasses'
    ]
  }

  elementContents() {
    return ['hasIcon', 'icon', 'hasDescription', 'items', 'class']
  }

  elementStyles() {
    return [
      'styles',
      'descContainerStyles',
      'iconContainerStyles',
      'iconStyles'
    ]
  }
}
